import React from "react";
import styles from "./ViewPasswordFormat.module.scss";
import { PASSWORD_INSTRUCTIONS } from "@/lib/constants";
import CrossIcon from "@/components/SVGComponents/CrossIcon";

const ViewPasswordFormat = ({ onClose }) => {
  return (
    <div className={styles.passwordNotes} onClick={(e) => e.stopPropagation()}>
      <strong>Note: <span className={styles.closeIcon} onClick={onClose}><CrossIcon /></span></strong>
      Password must -
      <ul>
        {PASSWORD_INSTRUCTIONS.map((instruction) => (
          <li key={instruction}>{instruction}</li>
        ))}
      </ul>
    </div>
  );
};

export default ViewPasswordFormat;
